import gql from 'graphql-tag'
import { PRODUCT_X_SELL_FRAGMENT } from './../fragments/productXsellFragment'
import {
  PRODUCT_AVAILABILITY_FRAGMENT,
  PRODUCT_ESTIMATED_DELIVERY_FRAGMENT,
} from '~/graphql/gql/product/fragments'
import { GQLProduct } from '~/graphql/__generated__/interfaces'

export interface GetProductByUrl {
  getProduct: GQLProduct | null
}

export const GET_PRODUCT_BY_URL = gql`
  query getProductByUrlForDetail(
    $url: String!
    $categoryId: String!
    $campaignUrl: String!
    $estimatedDeliveryType: EstimatedDeliveriesType
    $isBot: Boolean!
  ) {
    getProduct: getProductByUrlKey(urlKey: $url) {
      id
      title
      productTypeId
      division
      mainCategoryUrlKey
      description
      isAdultOnly
      menu {
        urlKey
      }
      breadcrumbs(categoryUrl: $categoryId) {
        title
        url
      }
      energyLabel {
        label
        class
      }
      rank {
        count
        rank
      }
      mainVariant {
        id
        productAmount
        price
        title
        groupAttributeValues
        brief
        priceType
        unitPrice
        priceRrp
        bonusSetIds
        defaultActualPrice
        discountMOCPrice
        rrpSavePercent
        originalSalePrice
        discountPromotionSalePrice
        discountPromotionPrice
        labels
        mainMenuPath
        variantUrl
        isAvailable
        inPromotion
        promotionEnd
        availableOutlets
        freeDelivery
        mallService(categoryId: $categoryId) {
          image
          text
          tooltip
        }
        discountAction {
          sendAfter
          actionId
          actionName
          validFrom
          validTo
          discount
        }
        availability {
          ...productAvailabilityFragment
        }
        estimatedDeliveries(type: $estimatedDeliveryType) {
          ...productEstimatedDeliveryFragment
        }
        marketplace {
          isMarketplace
          closeTime
          deliveryDelay
        }
        brand {
          title
          url
          mediaId
        }
        benefits {
          id
          name
          firstText
          secondText
          type
          discountPercent
          discountAmount
        }
        energyLabelMedia {
          mediaId
          mimeType
        }
        specialMedia {
          mediaId
          title
          mimeType
          priority
          switch
        }
        giftDetails {
          title
          giftId
          variants {
            count
            product {
              mainCategoryUrlKey
            }
            variant {
              price
              variantUrl
              title
              mediaId
              availability {
                countMall
                countExternal
                countSupplier
              }
            }
          }
        }
        mediaId
        mediaIds
        parameters {
          key
          url
          value
          paramValueId
        }
        hasWeeeFee
        return60DaysService
        extendedWarranty
        insurance
        bundles {
          ... on BaseProductBundle {
            type
            lowestPrice
            variants {
              id
              title
              actualPrice
              yearsNumber
            }
          }
          ... on DigitalContentBundle {
            type
            variants {
              id
              title
              actualPrice
              brief
              rrpSavePercent
            }
          }
        }
        materialType
        variantStickers(useCase: DETAIL) {
          name
          text
          date
        }
        recommendedVariants
        galleryVideos
        availability {
          key
          label
          countMall
        }
        discountPromotionAmount
        marketplaceType
      }
      marketplace {
        marketplacePartnerTitle
        marketplacePartnerUrl
      }
      fmcgCategory
      variantParameters {
        name
        label
        id
        items {
          colorId
          id
          disabled
          imageId
          label
          variantUrls {
            paramValue
            url
            id
          }
        }
      }
      secondPrice {
        link
        price
        text
        type
      }
      linkedProducts {
        bazaar {
          lowestPrice
          label
          ids
        }
        multipricing {
          lowestPrice
          ids
        }
      }
      review @skip(if: $isBot) {
        stats {
          messagesCount
          ranksCount
          averageRank
          stars {
            rank
            messagesCount
            rankPercentile
            rankPercent
            ranksCount
          }
        }
      }
      campaign(campaignUrl: $campaignUrl) {
        name
        url
        showProductCounter
        showActionPrice
        validTo
      }
      pictograms {
        title
        description
        url
        urlNewWindow
        hoverText
        mediaId
        gaTag
        priority
        isInstallment
      }
      testDriveRequest {
        isEnabled
        carModel
        baseUrl
      }
      ...xSellFragment
    }
  }

  ${PRODUCT_X_SELL_FRAGMENT}
  ${PRODUCT_AVAILABILITY_FRAGMENT}
  ${PRODUCT_ESTIMATED_DELIVERY_FRAGMENT}
`
